// function previewText() {
//   const textInput = document.querySelector('input[name="properties[Tekst]"]');
//   if (textInput) {
//     textInput.addEventListener('input', function() {
//       const displayTextBold = document.querySelector('#displayTextBold');
//       if (displayTextBold) {
//         displayTextBold.textContent = textInput.value;
//       }
//     });
//   }
// }

// function checkFont() {
//   const fontSwatches = document.querySelector('.bold_option_swatch:has(input[value="Lato"])');
//   if (fontSwatches) {
//     fontSwatches.addEventListener('click', function() {
//       setTimeout(() => {
//         const selectedFont = fontSwatches.querySelector('.bold_swatch_selected input[type="checkbox"]');
//         if (selectedFont) {
//           const previewField = document.querySelector('#displayTextBold');
//           if (previewField) {
//             console.log(selectedFont.value);
//             previewField.style.fontFamily = `${selectedFont.value}, sans-serif`;
//           }
//         }
//       }, 400);
//     });
//   }
// }

// // Function to execute the script when the class is found
// function executeScriptWhenClassFound() {
//   const intervalId = setInterval(() => {
//     const boldOptions = document.querySelector('.bold_options');
//     if (boldOptions) {
//       boldOptions.style.display = "block";
//       clearInterval(intervalId);
//       console.log('BOLD options found...')
//       var engravingCheckbox = document.querySelector('.bold_options input[name="properties[Personlig inngravering]"]').previousElementSibling;
//       engravingCheckbox.addEventListener('change', function() {
//         if (engravingCheckbox.checked) {
//           console.log('Listening for input...');
//           previewText();
//           checkFont();
//         }
//       })
//     }
//   }, 2000);
// }
// // Function to check periodically if the target class is present in the DOM
// function periodicallyCheckClassPresence() {
//     const targetClass = 'bold_options';
//     const targetElement = document.querySelector('.' + targetClass);
//     if (targetElement) {
//         // targetElement.style.display = "none";
//         console.log('Class "' + targetClass + '" is now present in the DOM.');
//         // If class found, execute the script
//         executeScriptWhenClassFound();
//         // Stop checking once the class is found
//         clearInterval(checkInterval);
//     } else {
//         console.log('Loading...');
//     }
// }
// // Create and append loading text to the specified ID
// const checkInterval = setInterval(periodicallyCheckClassPresence, 2000);


// document.addEventListener('DOMContentLoaded', function() {
//   function previewText() {
//     const textInput = document.querySelector('input[name="properties[Tekst]"]');
//     if (textInput) {
//       textInput.addEventListener('input', function() {
//         const displayTextBold = document.querySelector('#displayTextBold');
//         if (displayTextBold) {
//           displayTextBold.textContent = textInput.value;
//         }
//       });
//     }
//   }

//   function checkFont() {
//     const fontSwatches = document.querySelector('.bold_option_swatch:has(input[value="Lato"])');
//     if (fontSwatches) {
//       fontSwatches.addEventListener('click', function() {
//         setTimeout(() => {
//           const selectedFont = fontSwatches.querySelector('.bold_swatch_selected input[type="checkbox"]');
//           if (selectedFont) {
//             const previewField = document.querySelector('#displayTextBold');
//             if (previewField) {
//               console.log(selectedFont.value);
//               previewField.style.fontFamily = `${selectedFont.value}, sans-serif`;
//             }
//           }
//         }, 400);
//       });
//     }
//   }

//   // Function to execute the script when the class is found
//   function executeScriptWhenClassFound() {
//     const boldOptions = document.querySelector('.bold_options');
//     if (boldOptions) {
//       console.log('BOLD options found...');
//       var engravingCheckbox = document.querySelector('.bold_options input[name="properties[Personlig inngravering]"]').previousElementSibling;
//       if (engravingCheckbox) {
//         engravingCheckbox.addEventListener('change', function() {
//           if (engravingCheckbox.checked) {
//             console.log('Listening for input...');
//             previewText();
//             checkFont();
//           }
//         });
//       }
//     }
//   }

//   //mutationObserver to watch for changes in the DOM
//   const observer = new MutationObserver(function(mutationsList, observer) {
//     for (const mutation of mutationsList) {
//       if (mutation.type === 'childList') {
//         const boldOptions = document.querySelector('.bold_options');
//         if (boldOptions) {
//           console.log('Class "bold_options" is now present in the DOM.');
//           executeScriptWhenClassFound();
//           observer.disconnect();
//         }
//       }
//     }
//   });

//   // observing the document for added nodes
//   observer.observe(document.body, { childList: true, subtree: true });
// });





// There is a lot of custom code above that does not work properly, so I commented it out
// Font preview code is below, updated for performance and made sure it works without failing

const fontFamilies = ["Lato", "PT Serif", "Stardos Stencil", "Dancing Script", "Lobster", "Rock Salt"];

document.addEventListener('DOMContentLoaded', function () {
	BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function (event) {
		const boldOptions = document.querySelector(".bold_options_loaded");
		const attachedInputs = new WeakSet();

		const observer = new MutationObserver(() => {
			const fontInput = boldOptions.querySelector("input[name='properties[Tekst]']");
			if (fontInput && !attachedInputs.has(fontInput)) {
				fontInput.addEventListener("input", e => {
					document.getElementById("displayTextBold").textContent = e.target.value;
				});
				attachedInputs.add(fontInput);
			}
			
			document.querySelectorAll(".bold_option_swatch input[type='checkbox']").forEach(swatch => {
				if (!attachedInputs.has(swatch)) {
					swatch.addEventListener("change", e => {
						if (fontFamilies.includes(e.target.value)) {
							const preview = document.getElementById("displayTextBold");
							preview.style.fontFamily = e.target.value;
							preview.classList.toggle("rock-salt", e.target.value === "Rock Salt");
						}
					});
					attachedInputs.add(swatch);
				}
			});
		});

		observer.observe(boldOptions, { childList: true, subtree: true });
	});
});
